import { FunctionComponent } from 'react';
import { Image } from '@rebass/emotion';
import exclamationMarkBlue from './exclamationMarkBlue.svg';
import exclamationMarkYellow from './exclamationMarkYellow.svg';
import checkMarkGreen from './checkMarkGreen.svg';

const icons = {
  'exclamation-mark-blue': exclamationMarkBlue,
  'exclamation-mark-yellow': exclamationMarkYellow,
  'check-mark-green': checkMarkGreen,
};

interface IconProps extends Image {
  type: keyof typeof icons;
  [key: string]: unknown;
}

const Icon: FunctionComponent<IconProps> = ({ type, ...props }) => {
  return <Image {...props} src={icons[type]} />;
};

export default Icon;
